export const vaultGetters = {
    selectedVaultUsers: state => state.selectedVaultUsers,
};
